import React from "react";
import { Box, Typography } from "@mui/material";
import { connect } from "react-redux";

import { FOUNDRIES } from "../../constants";
import { getUserLocation } from "../../redux";
import { LogoImage } from "../../svgs";

import { ContactInfoStack } from "./styles";

const mapStateToProps = (state) => ({
  defaultLocationId: getUserLocation(state),
});

export const FoundryInfo = connect(mapStateToProps)(({
  poNumber,
  locationId,
  defaultLocationId = 1,
  showLogo,
  logoHeight = 60,
}) => {
  const location = locationId || defaultLocationId;
  const foundry = FOUNDRIES.find(({ id }) => id === location);
  const address = foundry?.address;

  return (
    <ContactInfoStack maxWidth="200px">
      {showLogo && (
        <Box
          component="img"
          src={LogoImage}
          height={`${logoHeight}px`}
          width={`${logoHeight * 2.23}px`}
        />
      )}
      {poNumber && (
        <Typography
          variant="barcode"
          fontSize="50px"
          lineHeight="50px"
          sx={{
            transform: "scaleX(0.5)",
            transformOrigin: "center left",
            textWrap: "nowrap",
          }}
        >
          *{poNumber}*
        </Typography>
      )}
      <Typography variant="boldCaptionL" sx={{ textWrap: "nowrap" }}>
        {foundry.company}
      </Typography>
      <Typography variant="caption">{address.street}</Typography>
      <Typography variant="caption">
        {address.city}, {address.state} {address.zip}
      </Typography>
      <Typography variant="caption">{foundry.cell}</Typography>
      <Typography variant="caption">{foundry.website}</Typography>
    </ContactInfoStack>
  );
});

export default FoundryInfo;
